// message
export const REMOVE_MESSAGE = 'REMOVE_MESSAGE';
export const HANDLE_BUSINESS_ERRORS = 'HANDLE_BUSINESS_ERRORS';
export const HANDLE_INTERNAL_ERRORS = 'HANDLE_INTERNAL_ERRORS';
export const HANDLE_SERVICE_ERRORS = 'HANDLE_SERVICE_ERRORS';
export const ADD_WARNING_MESSAGE = 'ADD_WARNING_MESSAGE';
export const HIDE_MESSAGE = 'HIDE_MESSAGE';
export const DISPLAY_DOWNLOAD_FILE_WARNING = 'DISPLAY_DOWNLOAD_FILE_WARNING';

// applicationSettings
export const FETCH_APPLICATION_SETTINGS = 'FETCH_APPLICATION_SETTINGS';
export const FETCH_APPLICATION_SETTINGS_SUCCESS =
    'FETCH_APPLICATION_SETTINGS_SUCCESS';
export const FETCH_APPLICATION_SETTINGS_FAILED =
    'FETCH_APPLICATION_SETTINGS_FAILED';

// applicationUser
export const LOGIN = 'LOGIN';
export const LOGIN_SUCCEEDED = 'LOGIN_SUCCEEDED';
export const LOGIN_FAILED = 'LOGIN_FAILED';
export const UPDATE_TOKEN = 'UPDATE_TOKEN';
export const LOGOUT = 'LOGOUT';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
export const LOGOUT_FAILED = 'LOGOUT_FAILED';
export const FETCH_APPLICATION_USER_DETAILS = 'FETCH_APPLICATION_USER_DETAILS';
export const FETCH_APPLICATION_USER_DETAILS_SUCCESS =
    'FETCH_APPLICATION_USER_DETAILS_SUCCESS';
export const FETCH_APPLICATION_USER_DETAILS_FAILED =
    'FETCH_APPLICATION_USER_DETAILS_FAILED';
export const FETCH_APPLICATION_CUSTOMER_FEEDBACK =
    'FETCH_APPLICATION_CUSTOMER_FEEDBACK';
export const FETCH_APPLICATION_CUSTOMER_FEEDBACK_SUCCESS =
    'FETCH_APPLICATION_CUSTOMER_FEEDBACK_SUCCESS';
export const FETCH_APPLICATION_CUSTOMER_FEEDBACK_FAILED =
    'FETCH_APPLICATION_CUSTOMER_FEEDBACK_FAILED';
export const FETCH_APPLICATION_USER_WORDINGS =
    'FETCH_APPLICATION_USER_WORDINGS';
export const FETCH_APPLICATION_USER_WORDINGS_SUCCESS =
    'FETCH_APPLICATION_USER_WORDINGS_SUCCESS';
export const FETCH_APPLICATION_USER_WORDINGS_FAILED =
    'FETCH_APPLICATION_USER_WORDINGS_FAILED';
export const FETCH_UNAUTHORISED_WORDINGS = 'FETCH_UNAUTHORISED_WORDINGS';
export const FETCH_UNAUTHORISED_WORDINGS_SUCCESS =
    'FETCH_UNAUTHORISED_WORDINGS_SUCCESS';
export const FETCH_UNAUTHORISED_WORDINGS_FAILED =
    'FETCH_UNAUTHORISED_WORDINGS_FAILED';
export const UPDATE_LANGUAGE_APPLICATION_USER =
    'UPDATE_LANGUAGE_APPLICATION_USER';
export const UPDATE_LANGUAGE_APPLICATION_USER_SUCCESS =
    'UPDATE_LANGUAGE_APPLICATION_USER_SUCCESS';
export const UPDATE_LANGUAGE_APPLICATION_USER_FAILED =
    'UPDATE_LANGUAGE_APPLICATION_USER_FAILED';
export const ADD_RESOURCE_FILE_TO_I18N = 'ADD_RESOURCE_FILE_TO_I18N';
export const ADD_RESOURCE_FILE_TO_I18N_SUCCESS =
    'ADD_RESOURCE_FILE_TO_I18N_SUCCESS';

export const UPDATE_APPLICATION_TERMS_CONSENTED =
    'UPDATE_APPLICATION_TERMS_CONSENTED';
export const UPDATE_APPLICATION_TERMS_CONSENTED_SUCCESS =
    'UPDATE_APPLICATION_TERMS_CONSENTED_SUCCESS';
export const UPDATE_APPLICATION_TERMS_CONSENTED_FAILED =
    'UPDATE_APPLICATION_TERMS_CONSENTED_FAILED';
// question
export const FETCH_QUESTIONS = 'FETCH_QUESTIONS';
export const FETCH_QUESTIONS_SUCCESS = 'FETCH_QUESTIONS_SUCCESS';
export const FETCH_QUESTIONS_FAILED = 'FETCH_QUESTIONS_FAILED';
export const CLEAR_QUESTION_STATE = 'CLEAR_QUESTION_STATE';
export const FETCH_ALL_QUESTIONS = 'FETCH_ALL_QUESTIONS';
export const FETCH_ALL_QUESTIONS_SUCCESS = 'FETCH_ALL_QUESTIONS_SUCCESS';
export const FETCH_ALL_QUESTIONS_FAILED = 'FETCH_ALL_QUESTIONS_FAILED';
export const FETCH_QUESTIONS_OF_CLAIM_TYPE_COMBO =
    'FETCH_QUESTIONS_OF_CLAIM_TYPE_COMBO';
export const FETCH_QUESTIONS_OF_CLAIM_TYPE_COMBO_SUCCESS =
    'FETCH_QUESTIONS_OF_CLAIM_TYPE_COMBO_SUCCESS';
export const FETCH_QUESTIONS_OF_CLAIM_TYPE_COMBO_FAILED =
    'FETCH_QUESTIONS_OF_CLAIM_TYPE_COMBO_FAILED';
export const FETCH_ALL_QUESTIONS_BY_GROUP = 'FETCH_ALL_QUESTIONS_BY_GROUP';
export const FETCH_ALL_QUESTIONS_BY_GROUP_SUCCESS =
    'FETCH_ALL_QUESTIONS_BY_GROUP_SUCCESS';
export const FETCH_ALL_QUESTIONS_BY_GROUP_FAILED =
    'FETCH_ALL_QUESTIONS_BY_GROUP_FAILED';

// questionType
export const FETCH_QUESTION_TYPES = 'FETCH_QUESTION_TYPES';
export const FETCH_QUESTION_TYPES_SUCCESS = 'FETCH_QUESTION_TYPES_SUCCESS';
export const FETCH_QUESTION_TYPES_FAILED = 'FETCH_QUESTION_TYPES_FAILED';

// claimType
export const FETCH_CLAIM_TYPES = 'FETCH_CLAIM_TYPES';
export const FETCH_CLAIM_TYPES_SUCCESS = 'FETCH_CLAIM_TYPES_SUCCESS';
export const FETCH_CLAIM_TYPES_FAILED = 'FETCH_CLAIM_TYPES_FAILED';
export const FETCH_CLAIM_TYPES_BY_POLICY_TYPE_AND_CLAIM_CATEGORY =
    'FETCH_CLAIM_TYPES_BY_POLICY_TYPE_AND_CLAIM_CATEGORY';
export const FETCH_CLAIM_TYPES_BY_POLICY_TYPE_AND_CLAIM_CATEGORY_SUCCESS =
    'FETCH_CLAIM_TYPES_BY_POLICY_TYPE_AND_CLAIM_CATEGORY_SUCCESS';
export const FETCH_CLAIM_TYPES_BY_POLICY_TYPE_AND_CLAIM_CATEGORY_FAILED =
    'FETCH_CLAIM_TYPES_BY_POLICY_TYPE_AND_CLAIM_CATEGORY_FAILED';
export const CLEAR_CLAIM_TYPES_STATE = 'CLEAR_CLAIM_TYPES_STATE';

// Currency
export const FETCH_CURRENCIES = 'FETCH_CURRENCIES';
export const FETCH_CURRENCIES_SUCCESS = 'FETCH_CURRENCIES_SUCCESS';
export const FETCH_CURRENCIES_FAILED = 'FETCH_CURRENCIES_FAILED';

// questionGroupStep
export const FETCH_QUESTION_GROUP_STEP = 'FETCH_QUESTION_GROUP_STEP';
export const FETCH_QUESTION_GROUP_STEP_SUCCESS =
    'FETCH_QUESTION_GROUP_STEP_SUCCESS';
export const FETCH_QUESTION_GROUP_STEP_FAILED =
    'FETCH_QUESTION_GROUP_STEP_FAILED';
export const FETCH_QUESTION_GROUP_STEP_BY_POLICY_TYPE_AND_CLAIM_CATEGORY_AND_CLAIM_TYPE =
    'FETCH_QUESTION_GROUP_STEP_BY_POLICY_TYPE_AND_CLAIM_CATEGORY_AND_CLAIM_TYPE';
export const FETCH_QUESTION_GROUP_STEP_BY_POLICY_TYPE_AND_CLAIM_CATEGORY_AND_CLAIM_TYPE_SUCCESS =
    'FETCH_QUESTION_GROUP_STEP_BY_POLICY_TYPE_AND_CLAIM_CATEGORY_AND_CLAIM_TYPE_SUCCESS';
export const FETCH_QUESTION_GROUP_STEP_BY_POLICY_TYPE_AND_CLAIM_CATEGORY_AND_CLAIM_TYPE_FAILED =
    'FETCH_QUESTION_GROUP_STEP_BY_POLICY_TYPE_AND_CLAIM_CATEGORY_AND_CLAIM_TYPE_FAILED';
export const FETCH_QUESTION_GROUP_STEP_BY_POLICY_TYPE_AND_CLAIM_CATEGORY_AND_CLAIM_TYPE_BY_CLAIM_APPLICATION =
    'FETCH_QUESTION_GROUP_STEP_BY_POLICY_TYPE_AND_CLAIM_CATEGORY_AND_CLAIM_TYPE_BY_CLAIM_APPLICATION_ID';
export const FETCH_QUESTION_GROUP_STEP_BY_POLICY_TYPE_AND_CLAIM_CATEGORY_AND_CLAIM_TYPE_BY_CLAIM_APPLICATION_SUCCESS =
    'FETCH_QUESTION_GROUP_STEP_BY_POLICY_TYPE_AND_CLAIM_CATEGORY_AND_CLAIM_TYPE_BY_CLAIM_APPLICATION_ID_SUCCESS';
export const FETCH_QUESTION_GROUP_STEP_BY_POLICY_TYPE_AND_CLAIM_CATEGORY_AND_CLAIM_TYPE_BY_CLAIM_APPLICATION_FAILED =
    'FETCH_QUESTION_GROUP_STEP_BY_POLICY_TYPE_AND_CLAIM_CATEGORY_AND_CLAIM_TYPE_BY_CLAIM_APPLICATION_ID_FAILED';
export const CLEAR_QUESTION_GROUP_STEP = 'CLEAR_QUESTION_GROUP_STEP';

// claimCategory
export const FETCH_CLAIM_CATEGORIES = 'FETCH_CLAIM_CATEGORIES';
export const FETCH_CLAIM_CATEGORIES_SUCCESS = 'FETCH_CLAIM_CATEGORIES_SUCCESS';
export const FETCH_CLAIM_CATEGORIES_FAILED = 'FETCH_CLAIM_CATEGORIES_FAILED';
export const FETCH_CLAIM_CATEGORIES_BY_POLICY_TYPE =
    'FETCH_CLAIM_CATEGORIES_BY_POLICY_TYPE';
export const FETCH_CLAIM_CATEGORIES_BY_POLICY_TYPE_SUCCESS =
    'FETCH_CLAIM_CATEGORIES_BY_POLICY_TYPE_SUCCESS';
export const FETCH_CLAIM_CATEGORIES_BY_POLICY_TYPE_FAILED =
    'FETCH_CLAIM_CATEGORIES_BY_POLICY_TYPE_FAILED';
export const CLEAR_CLAIM_CATEGORY_STATE = 'CLEAR_CLAIM_CATEGORY_STATE';

// policyType
export const FETCH_POLICY_TYPES = 'FETCH_POLICY_TYPES';
export const FETCH_POLICY_TYPES_SUCCESS = 'FETCH_POLICY_TYPES_SUCCESS';
export const FETCH_POLICY_TYPES_FAILED = 'FETCH_POLICY_TYPES_FAILED';
export const CLEAR_POLICY_TYPE = 'CLEAR_POLICY_TYPE';

// answer
export const CHANGE_ANSWER_STATE = 'CHANGE_ANSWER_STATE';
export const CLEAR_ANSWERS_FROM_GROUP_STEPS = 'CLEAR_ANSWERS_FROM_GROUP_STEPS';
export const GET_NO_SUBMITTED_DRAFT_CLAIM_APPLICATION_BY_USER =
    'GET_NO_SUBMITTED_DRAFT_CLAIM_APPLICATION_BY_USER';
export const GET_NO_SUBMITTED_DRAFT_CLAIM_APPLICATION_BY_USER_SUCCESS =
    'GET_NO_SUBMITTED_DRAFT_CLAIM_APPLICATION_BY_USER_SUCCESS';
export const GET_NO_SUBMITTED_DRAFT_CLAIM_APPLICATION_BY_USER_FAILED =
    'GET_NO_SUBMITTED_DRAFT_CLAIM_APPLICATION_BY_USER_FAILED';
export const GET_DRAFT_CLAIM_APPLICATION_BY_USER =
    'GET_DRAFT_CLAIM_APPLICATION_BY_USER';
export const GET_DRAFT_CLAIM_APPLICATION_BY_USER_SUCCESS =
    'GET_DRAFT_CLAIM_APPLICATION_BY_USER_SUCCESS';
export const GET_DRAFT_CLAIM_APPLICATION_BY_USER_FAILED =
    'GET_DRAFT_CLAIM_APPLICATION_BY_USER_FAILED';
export const GET_DRAFT_CLAIM_APPLICATION_LIST_BY_USER =
    'GET_DRAFT_CLAIM_APPLICATION_LIST_BY_USER';
export const GET_DRAFT_CLAIM_APPLICATION_LIST_BY_USER_SUCCESS =
    'GET_DRAFT_CLAIM_APPLICATION_LIST_BY_USER_SUCCESS';
export const GET_DRAFT_CLAIM_APPLICATION_LIST_BY_USER_FAILED =
    'GET_DRAFT_CLAIM_APPLICATION_LIST_BY_USER_FAILED';
export const CLEAR_ANSWERS_STATE = 'CLEAR_ANSWERS_STATE';
export const CLEAR_POLICY_TYPE_COMBINATION = 'CLEAR_POLICY_TYPE_COMBINATION';

//questionValidationRule
export const FETCH_QUESTION_VALIDATION_RULE = 'FETCH_QUESTION_VALIDATION_RULE';
export const FETCH_QUESTION_VALIDATION_RULE_SUCCESS =
    'FETCH_QUESTION_VALIDATION_RULE_SUCCESS';
export const FETCH_QUESTION_VALIDATION_RULE_FAILED =
    'FETCH_QUESTION_VALIDATION_RULE_FAILED';

// claimApplication
export const SEND_CLAIM_APPLICATION = 'SEND_CLAIM_APPLICATION';
export const SEND_CLAIM_APPLICATION_SUCCESS = 'SEND_CLAIM_CATEGORY_SUCCESS';
export const SEND_CLAIM_APPLICATION_FAILED = 'SEND_CLAIM_APPLICATION_FAILED';
export const UPDATE_CLAIM_APPLICATION = 'UPDATE_CLAIM_APPLICATION';
export const UPDATE_CLAIM_APPLICATION_SUCCESS =
    'UPDATE_CLAIM_APPLICATION_SUCCESS';
export const UPDATE_CLAIM_APPLICATION_FAILED =
    'UPDATE_CLAIM_APPLICATION_FAILED';
export const GET_CLAIM_APPLICATION_BY_ID = 'GET_CLAIM_APPLICATION_BY_ID';
export const GET_CLAIM_APPLICATION_BY_ID_SUCCESS =
    'GET_CLAIM_APPLICATION_BY_ID_SUCCESS';
export const GET_CLAIM_APPLICATION_BY_ID_FAILED =
    'GET_CLAIM_APPLICATION_BY_ID_FAILED';
export const GET_CLAIM_APPLICATIONS = 'GET_CLAIM_APPLICATIONS';
export const GET_CLAIM_APPLICATIONS_SUCCESS = 'GET_CLAIM_APPLICATIONS_SUCCESS';
export const GET_CLAIM_APPLICATIONS_FAILED = 'GET_CLAIM_APPLICATIONS_FAILED';
export const CHANGE_CLAIM_APPLICATION_STATE = 'CHANGE_CLAIM_APPLICATION_STATE';
export const REDIRECT_AFTER_CLAIM_SUBMIT = 'REDIRECT_AFTER_CLAIM_SUBMIT';
export const SEND_DRAFT_CLAIM_APPLICATION_BY_USER =
    'SEND_DRAFT_CLAIM_APPLICATION_BY_USER';
export const SEND_DRAFT_CLAIM_APPLICATION_BY_USER_SUCCESS =
    'SEND_DRAFT_CLAIM_APPLICATION_BY_USER_SUCCESS';
export const SEND_DRAFT_CLAIM_APPLICATION_BY_USER_FAILED =
    'SEND_DRAFT_CLAIM_APPLICATION_BY_USER_FAILED';
export const CREATE_WITHDRAWN_CLAIM_APPLICATION =
    'CREATE_WITHDRAWN_CLAIM_APPLICATION';
export const CREATE_WITHDRAWN_CLAIM_APPLICATION_SUCCESS =
    'CREATE_WITHDRAWN_CLAIM_APPLICATION_SUCCESS';
export const CREATE_WITHDRAWN_CLAIM_APPLICATION_FAILED =
    'CREATE_WITHDRAWN_CLAIM_APPLICATION_FAILED';
export const FETCH_CLAIM_APPLICATION_TEMPLATE =
    'FETCH_CLAIM_APPLICATION_TEMPLATE';
export const FETCH_CLAIM_APPLICATION_TEMPLATE_SUCCESS =
    'FETCH_CLAIM_APPLICATION_TEMPLATE_SUCCESS';
export const FETCH_CLAIM_APPLICATION_TEMPLATE_FAILED =
    'FETCH_CLAIM_APPLICATION_TEMPLATE_FAILED';

// documentType
export const FETCH_DOCUMENT_TYPES = 'FETCH_DOCUMENT_TYPES';
export const FETCH_DOCUMENT_TYPES_SUCCESS = 'FETCH_DOCUMENT_TYPES_SUCCESS';
export const FETCH_DOCUMENT_TYPES_FAILED = 'FETCH_DOCUMENT_TYPES_FAILED';
export const FETCH_DOCUMENT_TYPES_WITH_QUERY_PARAMS =
    'FETCH_DOCUMENT_TYPES_WITH_QUERY_PARAMS';
export const FETCH_DOCUMENT_TYPES_WITH_QUERY_PARAMS_SUCCESS =
    'FETCH_DOCUMENT_TYPES_WITH_QUERY_PARAMS_SUCCESS';
export const FETCH_DOCUMENT_TYPES_WITH_QUERY_PARAMS_FAILED =
    'FETCH_DOCUMENT_TYPES_WITH_QUERY_PARAMS_FAILED';

//claimApplicationBankAccount
export const UPDATE_CLAIM_APPLICATION_BANK_ACCOUNT =
    'UPDATE_CLAIM_APPLICATION_BANK_ACCOUNT';
export const UPDATE_CLAIM_APPLICATION_BANK_ACCOUNT_SUCCESS =
    'UPDATE_CLAIM_APPLICATION_BANK_ACCOUNT_SUCCESS';
export const UPDATE_CLAIM_APPLICATION_BANK_ACCOUNT_FAILED =
    'UPDATE_CLAIM_APPLICATION_BANK_ACCOUNT_FAILED';

export const FETCH_CLAIM_APPLICATION_BANK_ACCOUNT_ANSWERS =
    'FETCH_CLAIM_APPLICATION_BANK_ACCOUNT_ANSWERS';
export const FETCH_CLAIM_APPLICATION_BANK_ACCOUNT_ANSWERS_SUCCESS =
    'FETCH_CLAIM_APPLICATION_BANK_ACCOUNT_ANSWERS_SUCCESS';
export const FETCH_CLAIM_APPLICATION_BANK_ACCOUNT_ANSWERS_FAILED =
    'FETCH_CLAIM_APPLICATION_BANK_ACCOUNT_ANSWERS_FAILED';

// communicator message
export const FETCH_COMMUNICATOR_MESSAGE = 'FETCH_COMMUNICATOR_MESSAGE';
export const FETCH_COMMUNICATOR_MESSAGE_SUCCESS =
    'FETCH_COMMUNICATOR_MESSAGE_SUCCESS';
export const FETCH_COMMUNICATOR_MESSAGE_FAILED =
    'FETCH_COMMUNICATOR_MESSAGE_FAILED';
export const CREATE_COMMUNICATOR_MESSAGE = 'CREATE_COMMUNICATOR_MESSAGE';
export const CREATE_COMMUNICATOR_MESSAGE_SUCCESS =
    'CREATE_COMMUNICATOR_MESSAGE_SUCCESS';
export const CREATE_COMMUNICATOR_MESSAGE_FAILED =
    'CREATE_COMMUNICATOR_MESSAGE_FAILED';
export const FETCH_COMMUNICATOR_HISTORY = 'FETCH_COMMUNICATOR_HISTORY';
export const FETCH_COMMUNICATOR_HISTORY_SUCCESS =
    'FETCH_COMMUNICATOR_HISTORY_SUCCESS';
export const FETCH_COMMUNICATOR_HISTORY_FAILED =
    'FETCH_COMMUNICATOR_HISTORY_FAILED';

// claim review
export const FETCH_CLAIM_REVIEW_VALIDITY = 'FETCH_CLAIM_REVIEW_VALIDITY';
export const FETCH_CLAIM_REVIEW_VALIDITY_SUCCESS =
    'FETCH_CLAIM_REVIEW_VALIDITY_SUCCESS';
export const FETCH_CLAIM_REVIEW_VALIDITY_FAILED =
    'FETCH_CLAIM_REVIEW_VALIDITY_FAILED';
export const FETCH_CLAIM_REVIEW_DETAILS = 'FETCH_CLAIM_REVIEW_DETAILS';
export const FETCH_CLAIM_REVIEW_DETAILS_SUCCESS =
    'FETCH_CLAIM_REVIEW_DETAILS_SUCCESS';
export const FETCH_CLAIM_REVIEW_DETAILS_FAILED =
    'FETCH_CLAIM_REVIEW_DETAILS_FAILED';
export const ACCEPT_CLAIM_REVIEW = 'ACCEPT_CLAIM_REVIEW';
export const ACCEPT_CLAIM_REVIEW_SUCCESS = 'ACCEPT_CLAIM_REVIEW_SUCCESS';
export const ACCEPT_CLAIM_REVIEW_FAILED = 'ACCEPT_CLAIM_REVIEW_FAILED';
export const FETCH_REJECTION_FORM_CLAIM_REVIEW =
    'FETCH_REJECTION_FORM_CLAIM_REVIEW';
export const FETCH_REJECTION_FORM_CLAIM_REVIEW_SUCCESS =
    'FETCH_REJECTION_FORM_CLAIM_REVIEW_SUCCESS';
export const FETCH_REJECTION_FORM_CLAIM_REVIEW_FAILED =
    'FETCH_REJECTION_FORM_CLAIM_REVIEW_FAILED';
export const REJECT_CLAIM_REVIEW_WITH_REASON =
    'REJECT_CLAIM_REVIEW_WITH_REASON';
export const REJECT_CLAIM_REVIEW_WITH_REASON_SUCCESS =
    'REJECT_CLAIM_REVIEW_WITH_REASON_SUCCESS';
export const REJECT_CLAIM_REVIEW_WITH_REASON_FAILED =
    'REJECT_CLAIM_REVIEW_WITH_REASON_FAILED';
export const CHANGE_CLAIM_REVIEW_ANSWERS_STATE =
    'CHANGE_CLAIM_REVIEW_ANSWERS_STATE';
export const CHANGE_CLAIM_REVIEW_STATE = 'CHANGE_CLAIM_REVIEW_STATE';

//claim Documents
export const FETCH_CLAIM_DOCUMENT = 'FETCH_CLAIM_DOCUMENT';
export const FETCH_CLAIM_DOCUMENT_SUCCESS = 'FETCH_CLAIM_DOCUMENT_SUCCESS';
export const FETCH_CLAIM_DOCUMENT_FAILED = 'FETCH_CLAIM_DOCUMENT_FAILED';

//form types
export const FETCH_FORM_TYPES = 'FETCH_FORM_TYPES';
export const FETCH_FORM_TYPES_SUCCESS = 'FETCH_FORM_TYPES_SUCCESS';
export const FETCH_FORM_TYPES_FAILED = 'FETCH_FORM_TYPES_FAILED';
export const FETCH_FORM_TYPES_BY_POLICY_AND_CATEGORY_CODE =
    'FETCH_FORM_TYPES_BY_POLICY_AND_CATEGORY_CODE';
export const FETCH_FORM_TYPES_BY_POLICY_AND_CATEGORY_CODE_SUCCESS =
    'FETCH_FORM_TYPES_BY_POLICY_AND_CATEGORY_CODE_SUCCESS';
export const FETCH_FORM_TYPES_BY_POLICY_AND_CATEGORY_CODE_FAILED =
    'FETCH_FORM_TYPES_BY_POLICY_AND_CATEGORY_CODE_FAILED';
export const CLEAR_FORM_TYPES_STATE = 'CLEAR_FORM_TYPES_STATE';

//survey
export const FETCH_SURVEY_TYPE = 'FETCH_SURVEY_TYPE';
export const FETCH_SURVEY_TYPE_SUCCESS = 'FETCH_SURVEY_TYPE_SUCCESS';
export const FETCH_SURVEY_TYPE_FAILED = 'FETCH_SURVEY_TYPE_FAILED';
export const POST_SURVEY_ANSWERS = 'POST_SURVEY_ANSWERS';
export const POST_SURVEY_ANSWERS_SUCCESS = 'POST_SURVEY_ANSWERS_SUCCESS';
export const POST_SURVEY_ANSWERS_FAILED = 'POST_SURVEY_ANSWERS_FAILED';
